module.exports = __webpack_public_path__ + "static/img/imgContent.ac6be1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgContent.png
// module id = dWoO
// module chunks = 0